import { apiRequest } from "../../services/apiService";
import {
    GET_LEAD_ERASURE_RULES_REQUEST,
    GET_LEAD_ERASURE_RULES_SUCCESS,
    GET_LEAD_ERASURE_RULES_FAIL,
    ADD_LEAD_ERASURE_RULE_REQUEST,
    ADD_LEAD_ERASURE_RULE_SUCCESS,
    ADD_LEAD_ERASURE_RULE_FAIL,
    UPDATE_LEAD_ERASURE_RULE_REQUEST,
    UPDATE_LEAD_ERASURE_RULE_SUCCESS,
    UPDATE_LEAD_ERASURE_RULE_FAIL,
    DELETE_LEAD_ERASURE_RULE_REQUEST,
    DELETE_LEAD_ERASURE_RULE_SUCCESS,
    DELETE_LEAD_ERASURE_RULE_FAIL,
    TOGGLE_LEAD_ERASURE_RULE_REQUEST,
    TOGGLE_LEAD_ERASURE_RULE_SUCCESS,
    TOGGLE_LEAD_ERASURE_RULE_FAIL,
} from "../constant";

export const getLeadErasureRules = (survey_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_LEAD_ERASURE_RULES_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getLeadErasureRules?survey_id=${survey_id}`,
        });
        if (response) {
            dispatch({ type: GET_LEAD_ERASURE_RULES_SUCCESS, payload: response.data?.data || [] });
        } else {
            dispatch({ type: GET_LEAD_ERASURE_RULES_FAIL });
        }
    };
};

export const addLeadErasureRule = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: ADD_LEAD_ERASURE_RULE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: '/survey/addLeadErasureRule',
            data,
        });
        if (response?.data?.statusCode === 200) {
            dispatch({ type: ADD_LEAD_ERASURE_RULE_SUCCESS, payload: response.data });
            if (successCallback) successCallback();
        } else {
            dispatch({ type: ADD_LEAD_ERASURE_RULE_FAIL });
        }
    };
};

export const updateLeadErasureRule = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_LEAD_ERASURE_RULE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PUT',
            url: '/survey/updLeadErasureRule',
            data,
        });
        if (response?.data?.statusCode === 200) {
            dispatch({ type: UPDATE_LEAD_ERASURE_RULE_SUCCESS, payload: response.data });
            if (successCallback) successCallback();
        } else {
            dispatch({ type: UPDATE_LEAD_ERASURE_RULE_FAIL });
        }
    };
};

export const deleteLeadErasureRule = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_LEAD_ERASURE_RULE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: '/survey/delLeadErasureRule',
            data,
        });
        if (response?.data?.statusCode === 200) {
            dispatch({ type: DELETE_LEAD_ERASURE_RULE_SUCCESS, payload: response.data });
            if (successCallback) successCallback();
        } else {
            dispatch({ type: DELETE_LEAD_ERASURE_RULE_FAIL });
        }
    };
};

export const toggleLeadErasureRule = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LEAD_ERASURE_RULE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: '/survey/toggleLeadErasureRule',
            data,
        });
        if (response?.data?.statusCode === 200) {
            dispatch({ type: TOGGLE_LEAD_ERASURE_RULE_SUCCESS, payload: response.data });
            if (successCallback) successCallback();
        } else {
            dispatch({ type: TOGGLE_LEAD_ERASURE_RULE_FAIL });
        }
    };
};
